import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import ActionsForm from '@/shared/mixins/actionsForm'
import ModalNewDespesas from '../ModalNewDespesas/ModalNewDespesas.vue'
import CollapseImageComissionItens from '../CollapseImageComissionItens/CollapseImageComissionItens'
import ExpenseItemRepository from '@/shared/http/repositories/business/expenseitem.js'
import ExpenseReceiptsRepository from '@/shared/http/repositories/business/expensereceipts.js'
import ExpenseRepository from '@/shared/http/repositories/business/expense.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import JSZip from 'jszip'
import Tools from '@/components/tools/Tools.js'
import { saveAs } from 'file-saver'
import ModalEditDespesas from '../ModalEditDespesas/ModalEditDespesas.vue'
import toastr from 'toastr'

export default {
  name: 'FormDetailsComission',
  components: {HeadDetailsGama, ModalNewDespesas, ModalEditDespesas, CollapseImageComissionItens},
  mixins: [ActionsForm],
  emits: ['tabIndex'],
  data () {
    return {
      headTable: ['Status', 'Despesa', 'Previsão de Gastos', 'Qtd.', 'Valor Gasto', 'Total Final', 'Observação', ''],
      dataExpense: [],
      tabIndex: 0,
      TempoMaximo: false,
      despesaData: [],
      valuePrevisto: 0.0,
      dataEnumItens: [],
      despesaitemid: null,
      dataAnexos: [],
      searchFiles: '',
      flSearch: false,
      datafilter: [],
      valueTotalFinal: 0.0,
      valueReembolso: 0.0,
      dataBase64Pdf: '',
      valueDesconta: 0.0,
      isPdf: false,
      dataDespesaHistory: [],
      dataSituacao: [],
      StatusSituacao: false,
      tab: null,
      logAccountability: [],
      logallfilter: [],
      serachiput: '',
      meses: ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ']
    }
  },
  computed: {
    GetdataExpense: function () {
      if (this.dataExpense.length > 0) {
        return this.dataExpense.filter((Element) => Element.despesaTipo.forma !== 1)
      }
    },
    GetdataAnexos: function () {
      if (this.searchFiles.length > 0) {
        this.datafilter = this.dataAnexos.filter((Element) => Element.name.toUpperCase().includes(this.searchFiles.toUpperCase()))
        return this.datafilter
      } else {
        return this.dataAnexos
      }
    }
  },
  watch: {
    tabIndex (novoValor) {
      this.$emit('tabIndex', novoValor)
    },
    searchFiles (newValue) {
      if (newValue.length > 0) {
        this.flSearch = true
        this.datafilter = this.dataAnexos.filter((Element) => Element.name.toUpperCase().includes(newValue.toUpperCase()))
      } else {
        this.flSearch = false
      }
    },
    serachiput (newValue) {
      this.logallfilter = this.logAccountability.filter((Element) => Element.titulo.toUpperCase().includes(newValue.toUpperCase()))
    }
  },
  props: {
    dataDetails: {
      type: Object
    }
  },
  mounted () {
    this.getEnumDespesaItem()
    this.getAnexos()
    this.getAllHistory()
    this.DataDespesaViagemFim()
    this.getStatusAdiantamento()
    this.GetLogById()
  },
  methods: {
    onChange (data) {
      this.despesaitemid = data.id
      this.$refs['history-lote-term'].show()
    },
    close () {
      this.$refs['history-lote-term'].hide()
      this.despesaitemid = null
    },
    cancel () {
      this.$refs['history-lote-term'].hide()
      this.despesaitemid = null
    },
    getAnexos () {
      loading.push()
      ExpenseReceiptsRepository.GetAllByDespesa(this.dataDetails.id)
        .then(Response => {
          this.dataAnexos = Response.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    editDes (obj) {
      this.$refs.ModalEditDespesas.show(obj)
    },
    onDragEnter (e) {
      e.target.children[0].style.color = 'white'
      e.target.style.background = '#00552d'
    },
    onDragLeave (e) {
      e.target.style.background = 'white'
      e.target.children[0].style.color = 'black'
    },
    openImg (e, data) {
      // Get the modal
      var modal = document.getElementById('myModal')

      // Get the image and insert it inside the modal - use its "alt" text as a caption
      modal.style.display = 'block'
      // Get the <span> element that closes the modal
      var span = document.querySelector('.close')

      // When the user clicks on <span> (x), close the modal
      span.onclick = function () {
        modal.style.display = 'none'
      }
      this.isPdf = data.isPdf
      if (!data.isPdf) {
        var img = e.target
        var modalImg = document.getElementById('img01')
        modalImg.src = img.src
        var captionText = document.getElementById('caption')

        captionText.innerHTML = img.alt
      } else {
        this.dataBase64Pdf = data.arquivo
      }
    },
    getStatusAdiantamento () {
      loading.push()
      ExpenseRepository.GetEnumSituacao()
        .then(Response => {
          loading.pop()
          this.dataSituacao = Response.data
        })
        .catch(Error => loading.pop())
    },
    getAllHistory () {
      loading.push()
      ExpenseRepository.GetAllHistory(this.dataDetails.favorecidoID)
        .then(Response => {
          this.dataDespesaHistory = Response.data.data
          this.$refs.tableGridHistoryDespesa.LoadAllByData(Response)
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    setFormaCityState (obj) {
      let result = null
      if (obj && obj.estado) {
        result = obj.nome + ' ' + obj.estado.sigla
      } else {
        result = obj.nome
      }
      return result
    },
    inputOpen () {
      document.getElementById('input-').click()
    },
    verificarStatus (situacao) {
      if (this.dataSituacao.length > 0) {
        let sit = this.dataSituacao.find((Element) => parseInt(Element.value) === situacao)
        if (sit !== undefined) {
          return sit.text
        }
      }
      return 'N/D'
    },
    sendFile (e) {
      let conf = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let files = []
      if (e.target.files === undefined) {
        e.target.style.background = 'white'
        e.target.children[0].style.color = 'black'
        files = e.dataTransfer.files
      } else {
        files = e.target.files
      }
      let file = new FormData()
      for (let i = 0; i < files.length; i++) {
        file.append('file', files[i])
      }
      loading.push()
      ExpenseReceiptsRepository.SendFile(this.dataDetails.id, file, conf)
        .then(Response => {
          loading.pop()
          this.getAnexos()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    deleteDespesa (data) {
      loading.push()
      if (data.valorTotal !== 0) {
        toast.warning('Não foi possivel excluir o item, pois ouve a previsão de gastos!!')
        loading.pop()
      } else {
        ExpenseItemRepository.DeleteDespesaItem(data.id)
          .then(Response => {
            loading.pop()
            toast.success('Item deletado com sucesso!!')
            this.onLoad()
          })
          .catch(Error => {
            loading.pop()
            toast.error('Não foi possivel deleta o item!!')
          })
      }
    },
    reprovaDespesaItem () {
      loading.push()
      ExpenseItemRepository.ReprovaDespesa(this.despesaitemid)
        .then(Response => {
          loading.pop()
          toast.success('Item reprovado com sucesso!!')
          this.onLoad()
        })
        .catch(Error => {
          loading.pop()
          toast.error('Não foi encontrar a despesa!!')
        })
    },
    onLoad () {
      loading.push()
      ExpenseItemRepository.GetAll(this.dataDetails.id)
        .then(Response => {
          loading.pop()
          this.dataExpense = Response.data.data
          this.$refs.tableGridExpenseItem.LoadAllByData(Response)
          this.valuePrevisto = 0.0
          this.valueTotalFinal = 0.0
          this.valueDesconta = 0.0
          this.valueReembolso = 0.0
          this.dataExpense.forEach(Element => {
            if (Element.despesaTipo.forma === 1) {
              this.valuePrevisto += Element.despesa.valorSolicitado
            }
            if (Element.despesaTipo.forma === 0 && Element.situacao === 1) {
              this.valueTotalFinal += Element.valorTotalFinal
            }
          })
          let verificaValor = this.valuePrevisto - this.valueTotalFinal
          if (verificaValor < 0) {
            this.valueReembolso = verificaValor * -1
            this.valueDesconta = 0
          } else {
            this.valueReembolso = 0
            this.valueDesconta = verificaValor
          }

          // this.valueDesconta = this.dataDetails.valorSolicitado - this.valueTotalFinal
          // if (this.valueDesconta < 0) {
          //   this.valueReembolso = this.valueTotalFinal
          // } else {
          //   this.valueReembolso = this.valueTotalFinal - this.valueDesconta
          // }
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    DataDespesaViagemFim () {
      loading.push()
      ExpenseRepository.GetByDespesaId(this.dataDetails.id)
        .then(Response => {
          if (this.hasRole(this.roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)) {
            this.TempoMaximo = Response.data
          } else {
            this.TempoMaximo = false
          }
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },

    despesaItemSituacao () {
      loading.push()
      ExpenseRepository.AlteraSituacaDespesa(this.dataDetails.id)
        .then(Response => {
          if (Response.data) {
            toast.success('Prestação de Contas alterada para Ag Aprovação da Diretoria')
            this.StatusSituacao = true
            this.$emit('Situacao', this.StatusSituacao)
            this.onLoad()
            this.GetLogById()
          } else {
            toastr.Error('Não foi possivel alterar a Prestação de Contas!!')
          }
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
          toastr.Error('error!!')
        })
    },

    getEnumDespesaItem () {
      ExpenseItemRepository.GetEnum()
        .then(Response => {
          this.dataEnumItens = Response.data
        })
        .catch(Error => console.log(Error))
    },
    deleteFile (id) {
      loading.push()
      this.datafilter = this.datafilter.filter((Element) => Element.id !== id)
      ExpenseReceiptsRepository.DeleteFile(id)
        .then(Response => {
          if (Response.data) {
            this.getAnexos()
            toast.success('Arquivo deletado com sucesso!!')
          } else {
            toastr.Error('Não foi possivel deletar o arquivo!!')
          }
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
          toastr.Error('Não foi possivel deletar o arquivo!!')
        })
    },
    dawnloadGrup () {
      var zip = new JSZip()
      let despesaItem = this.dataExpense
      if (despesaItem.length > 0) {
        let img = zip.folder('Recibos')
        let get = this.dataAnexos
        for (let z = 0; z < get.length; z++) {
          img.file(get[z].name, get[z].arquivo, {base64: true, createFolders: true})
        }
      }
      zip.generateAsync({
        type: 'blob'
      }).then(function (content) {
        saveAs(content, 'midias.zip')
      })
    },
    getColorSituacao (value) {
      if (this.dataEnumItens.length === 0) return 'N/D'
      let situacao = this.dataEnumItens.find((Element) => parseInt(Element.value) === value)
      if (situacao !== undefined) return situacao.color
      return 'N/D'
    },
    newDespesa () {
      this.$refs.ModalNewDespesas.show()
    },
    getSituacaoDescription (value) {
      if (this.dataEnumItens.length === 0) return 'N/D'
      let situacao = this.dataEnumItens.find((Element) => parseInt(Element.value) === value)
      if (situacao !== undefined) return situacao.text
      return 'N/D'
    },
    GetLogById () {
      loading.push()
      ExpenseRepository.GetLogById(this.dataDetails.id)
        .then(Response => {
          this.logAccountability = Response.data
        })
    },
    mostrarNomeMes (event) {
      const mesInt = parseInt(event)
      if (mesInt >= 1 && mesInt <= 12) {
        return this.meses[mesInt - 1]
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/FormDetailsComission/FormDetailsComission.js